// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min';

// Import language files
import 'froala-editor/js/languages/tr';

// Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/image_tui.min';

// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';

Vue.use(VueFroala);
